"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _replaceSpecialCharacters = _interopRequireDefault(require("../replaceSpecialCharacters"));
var createFilterString = function createFilterString(filters) {
  var isPro = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var filterString = "";
  var orderString = "";
  if (Object.keys(filters).length === 0) {
    return "";
  }
  if (!Array.isArray(filters)) {
    filters = [filters];
  }
  filters.forEach(function (filter) {
    if (filter.value) {
      if (filter.id === "sort") {
        var _filter$value$id$spli = filter.value.id.split("-"),
          _filter$value$id$spli2 = (0, _slicedToArray2["default"])(_filter$value$id$spli, 2),
          name = _filter$value$id$spli2[0],
          direction = _filter$value$id$spli2[1];
        orderString += "?dir=".concat(direction, "&order=").concat(name);
      } else if (filter.type === "range") {
        if (filter.id === "capacity") {
          if (!isPro) {
            filterString += "".concat(filter.id, "-").concat(filter.value.from / 1000, "-").concat(filter.value.to / 1000, "-");
            return;
          }
          filterString += "".concat(filter.id, "-").concat(filter.value.from, "-").concat(filter.value.to, "-");
        } else {
          filterString += "".concat(filter.id, "-").concat(filter.value.from, "-").concat(filter.value.to, "-");
        }
      } else {
        filterString += "".concat(filter.value.map(function (val) {
          if (!val.name) {
            var filterName = "";
            filter.items.map(function (item) {
              if (item.value_string === val.id) {
                filterName += "".concat(item.name);
              }
            });
            return filterName;
          } else {
            return val.name;
          }
        }).join("-").replace(/ \/ /g, "_").replace(/ & /g, "_").replace(/ /g, "_"), "-");
      }
    }
  });
  filterString = (0, _replaceSpecialCharacters["default"])(filterString.substring(0, filterString.length - 1)).toLowerCase();
  if (filterString || orderString) {
    if (isPro) {
      filterString = filterString ? "/".concat(filterString).concat(orderString) : "".concat(orderString);
    } else {
      filterString = "/".concat(filterString).concat(orderString);
    }
  }
  return filterString.indexOf("-") === 1 ? filterString.replace("-", "") : filterString;
};
var _default = createFilterString;
exports["default"] = _default;